module.exports = __webpack_public_path__ + "img/cover-slot-bg-mobile.7a1c3ec9.jpg";